var BlockView = require('views/block/base-block-view');
import { SessionStorageService } from 'services/web-storage-service';

var SessionView = BlockView.extend({
  initialize: function() {
    //this block is expected to get a custom template
    let contentObject = SessionStorageService.getByDotString(this.model.get('session_key'));
    if(contentObject !== undefined) {
      if(Array.isArray(contentObject)) {
        this.model.set('items', contentObject);
      } else if(typeof contentObject === 'object') {
        this.model.set('item', contentObject);
      } else {
        this.model.set('item', contentObject);
      }
    }
    BlockView.prototype.initialize.apply(this, arguments);
  },
  play: function() {
    this.readyToGo();
  }
});

module.exports = SessionView;